module.exports = __webpack_public_path__ + "img/wordpress.2eb66edd.png";